"use client";

function stopPropagation(e: React.MouseEvent<HTMLDivElement>) {
  e.stopPropagation();
}

export const EventPropagationBoundary = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={className} onClick={stopPropagation} role='presentation'>
      {children}
    </div>
  );
};
